import { Navigate } from "react-router-dom";

interface ProtectedRouteProps {
  element: React.ElementType;
}

const ProtectedRoute = ({ element: Component, ...rest }: ProtectedRouteProps & Record<string, unknown>) => {
  const token = localStorage.getItem("token");

  return token ? <Navigate to="/" /> : <Component {...rest} />;
};

export default ProtectedRoute;
